import { Printer } from 'lucide-react'
import { RuntimeCard } from '@/components/results/RuntimeCard.tsx'
import { FormulaExplanationPanel } from '@/components/results/FormulaExplanationPanel.tsx'
import { AssumptionsSummary } from '@/components/results/AssumptionsSummary.tsx'
import { MultiUnitOutput } from '@/components/results/MultiUnitOutput.tsx'
import { Disclaimer } from '@/components/shared/Disclaimer.tsx'

export function ResultsPanel() {
  const handlePrint = () => {
    window.print()
  }

  return (
    <div className="results-panel">
      <h2 className="results-panel__heading">Results</h2>
      <div className="results-panel__actions">
        <button type="button" className="results-panel__print-btn" onClick={handlePrint} aria-label="Print report">
          <Printer size={14} /> Print Report
        </button>
      </div>
      <RuntimeCard />
      <FormulaExplanationPanel />
      <AssumptionsSummary />
      <MultiUnitOutput />
      <Disclaimer />
    </div>
  )
}
